import { DollarSign, TrendingUp, Truck, Users } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../../../components/ui/accordion";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../../components/ui/card";
import { EntregoCheckoutItem } from "../types";
import { formatDateBR } from "../../../../../utils/format-utils";
import { CheckoutActionButtons } from "./checkout-action-buttons";
import { CheckoutStatCard } from "./checkout-stat-card";
import { DescricaoSummaryTable } from "./descricao-summary-table";
import { ProcessedFilesTable } from "./processed-files-table";

interface CheckoutItemCardProps {
  checkout: EntregoCheckoutItem;
  onConfirmCheckout: (filterDate: string, ops: string) => void;
  // TEMP-SPLIT-OFERTA: opcional — sem ele o card mostra só o botão WhatsApp.
  // Ficou opcional quando o piloto foi encerrado (2026-10-02) e a página deixou de
  // passá-lo; antes era obrigatório e ligava o botão "Enviar Ofertas".
  onEnviarOfertas?: (filterDate: string, ops: string) => void;
  onStartDoc: (filterDate: string, ops: string) => void;
  onSubmitRemessa: (filterDate: string, ops: string) => void;
  isConfirming: boolean;
  isEnviandoOfertas?: boolean;
  isStartingDoc: boolean;
  isSubmittingRemessa: boolean;
}

export function CheckoutItemCard({
  checkout,
  onConfirmCheckout,
  onEnviarOfertas,
  onStartDoc,
  onSubmitRemessa,
  isConfirming,
  isEnviandoOfertas,
  isStartingDoc,
  isSubmittingRemessa,
}: CheckoutItemCardProps) {
  const dateCheckout = checkout.date_to_checkout.slice(0, 10);
  const uniqueDeliverers =
    checkout.entregadores_unicos_cadastrados ||
    checkout.entregadores_unicos ||
    0;
  const temFranquias = (checkout.filesProcessed?.length ?? 0) > 0;
  const temResumo = (checkout.resumoDescricao?.length ?? 0) > 0;

  return (
    <Card className="mb-6">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">
            Checkout - {formatDateBR(dateCheckout)}
          </CardTitle>
          <CheckoutActionButtons
            status={checkout.status}
            ops={checkout.ops}
            date={dateCheckout}
            onConfirmCheckout={() =>
              onConfirmCheckout(dateCheckout, checkout.ops)
            }
            onEnviarOfertas={
              onEnviarOfertas &&
              (() => onEnviarOfertas(dateCheckout, checkout.ops))
            }
            onStartDoc={() => onStartDoc(dateCheckout, checkout.ops)}
            onSubmitRemessa={() => onSubmitRemessa(dateCheckout, checkout.ops)}
            isConfirming={isConfirming}
            isEnviandoOfertas={isEnviandoOfertas}
            isStartingDoc={isStartingDoc}
            isSubmittingRemessa={isSubmittingRemessa}
          />
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
          <CheckoutStatCard
            title="Operação"
            value={checkout.ops}
            icon={Truck}
            valueType="text"
          />
          <CheckoutStatCard
            title="MB únicos"
            value={uniqueDeliverers}
            icon={Users}
            valueType="integer"
          />
          <CheckoutStatCard
            title="Ticket Médio"
            value={checkout.ticket_medio}
            icon={TrendingUp}
            valueType="cents"
          />
          <CheckoutStatCard
            title="Valor de Face Acumulado"
            value={checkout.total_valor_face}
            icon={DollarSign}
            valueType="cents"
          />
        </div>

        {(temFranquias || temResumo) && (
          <Accordion type="single" collapsible className="mt-4">
            {temFranquias && (
              <AccordionItem value="files">
                <AccordionTrigger>
                  Arquivos processados Franqueados dia: {dateCheckout}
                </AccordionTrigger>
                <AccordionContent>
                  <ProcessedFilesTable files={checkout.filesProcessed!} />
                </AccordionContent>
              </AccordionItem>
            )}

            {temResumo && (
              <AccordionItem value="resumo">
                <AccordionTrigger>
                  Resumo por descrição dia: {dateCheckout}
                </AccordionTrigger>
                <AccordionContent>
                  <DescricaoSummaryTable rows={checkout.resumoDescricao!} />
                </AccordionContent>
              </AccordionItem>
            )}
          </Accordion>
        )}
      </CardContent>
    </Card>
  );
}
